export const MODALS = {
    FEATURES: 'FEATURES',
    ADD_PRICE: 'ADD_PRICE',
    EDIT_PRICE: 'EDIT_PRICE',
    DELETE_PRICE: 'DELETE_PRICE',
    ADD_INFLATED_PRICE: 'ADD_INFLATED_PRICE',
    EDIT_INFLATED_PRICE: 'EDIT_INFLATED_PRICE',
}
